import { render, staticRenderFns } from "./folderSelect.vue?vue&type=template&id=24fd85cd"
import script from "./folderSelect.vue?vue&type=script&lang=js"
export * from "./folderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports